import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, memoryLocalCache } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getRemoteConfig, fetchAndActivate, getValue } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: "AIzaSyB55-xq0nd-J2B-wKZ-bhiNHupks7zVVBA",
  authDomain: "vrcricket-65cd3.firebaseapp.com",
  databaseURL: "https://vrcricket-65cd3-default-rtdb.firebaseio.com",
  projectId: "vrcricket-65cd3",
  storageBucket: "vrcricket-65cd3.firebasestorage.app",
  messagingSenderId: "350774042111",
  appId: "1:350774042111:web:51c23a76fe6fa6c9ecdbca",
  measurementId: "G-CCSSZDKGYC"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const db = initializeFirestore(app, {
  localCache: memoryLocalCache()
});

// RTDB used for presence/heartbeat and maintenance mode listener
const rtdb = getDatabase(app);

// Remote Config — version gate + feature flags
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis =
    process.env.NODE_ENV === 'development' ? 0 : 3600000; // 0 for dev, 1 hour for production
remoteConfig.defaultConfig = {
    min_version_cricketxtreme: '0.0.0',
    update_message: 'A major update is required. Please update to continue.',
    force_update: false,
};

const appId = 'vrcricket-cricketx';

export { app, auth, db, rtdb, remoteConfig, fetchAndActivate, getValue, appId };

